import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Card";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useFirebaseApp } from "reactfire";
import Logo from "../../Assets/img/logo.png";

const useStyles = makeStyles((theme) => ({
  inputRounded: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "25px",
    },
    "& fieldset": {
      borderColor: "#FBA5A6",
    },
    "&:hover fieldset": {
      borderColor: "#f28c8d",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#f05d5f",
    },
  },

  root: { height: "100vh" , 
  },
  paper: { margin: theme.spacing(8, 4), display: "flex", flexDirection: "column", alignItems: "center" },
  form: { width: "60%", marginTop: theme.spacing(1) },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FBA5A6",
  },

  
  responsiveCard: {
    margin:"20px",
    width: "500px",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0px 4px 12px rgba(148, 22, 22, 0.3)",
    [theme.breakpoints.up('sm')]: {
      maxWidth:"450px",
    },
  },
  

  responsiveImage: {
    width: "100%",
    maxWidth: "400px",
    height: "auto", 
    marginBottom: "20px",
    objectFit: "contain",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", 
    width: "100%",
  },
  centeredContainer: {
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    height: "calc(100vh - 100px)",
    marginBottom: "180px", 

  },
}));

export default function Login() {
  const [emailstate, setEmail] = useState("");
  const [passwordstate, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); 

  let fb = useFirebaseApp();
  let History = useHistory();
  const classes = useStyles();

  const SignIn = () => {
    setErrorMessage(""); 
    fb.auth()
      .signInWithEmailAndPassword(emailstate, passwordstate)
      .then(() => History.push("/"))
      .catch(() => setErrorMessage("⚠️ Correo o contraseña incorrectos. Verifica tus datos."));
  };
  

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} sm={12} md={12} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <img style={{ width: '350px', height: 'auto' }} src={Logo} alt="logo" />
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Correo electrónico"
              autoComplete="email"
              autoFocus
              className={classes.inputRounded}
              onChange={(e) => setEmail(e.target.value)}
            
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Contraseña"
              type="password"
              autoComplete="current-password"
              className={classes.inputRounded}
              onChange={(e) => setPassword(e.target.value)}
            />
            {errorMessage && (
              <Typography color="error" variant="body2" align="center">
                {errorMessage}
              </Typography>
            )}

            <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={SignIn}>
              Iniciar Sesion
            </Button>
          </form>
        </div>

      </Grid>
    </Grid>
  );
}